import React, { useEffect, useState } from "react";
import Login from "./pages/login";

function App() {
  const [isFullAutoLogin, setIsFullAutoLogin] = useState(false);
  useEffect(() => {
    let ssoToken = localStorage.getItem("sso_token");
    const params = new URLSearchParams(window.location.search);
    let sso = params.get("sso");
    let sig = params.get("sig");

    console.log({
      step: 'react is loaded and checking if isFullAutoLogin ',
      localStorage,
      result: ssoToken && sso && sig,
      ssoToken,
      sso,
      sig,
    });
    setIsFullAutoLogin(ssoToken && sso && sig);
  }, []);

  return isFullAutoLogin ? <></> : <Login />;
}

export default App;
